export const NAV_MASTER = {
  MAIN_CHAT: '1', // 相談しチャオ
  RAG_CHAT: '3', // RAGっチャオ
  SUMMARY: '4', // 議事録っチャオ
  TRANSLATION: '5', // 翻訳しチャオ
  IMAGE_GENERATION: '6', // 画像生成しチャオ
}
